<template>
    <div class="pages__nav">
        <p v-if="settings.projects != 'false'" :class="projects" @click="clickProjects">Projecten</p>
        <p v-if="settings.nieuws != 'false'" :class="nieuws" @click="clickNieuws">Nieuws</p>
        <p v-if="settings.vacatures != 'false'" :class="vacatures" @click="clickVacatures">Vacatures</p>
        <p v-if="settings.openingsuren != 'false'" :class="openingsuren" @click="clickOpeningsuren">Openingsuren</p>
    </div>
</template>
<script>
export default {
    inject:['status', 'user', 'appSettings'],
    data(){
        return{
            projects: "pages__nav__btn pages__nav__btn__active",
            nieuws: "pages__nav__btn",
            vacatures: "pages__nav__btn",
            openingsuren: "pages__nav__btn",
            media: "pages__nav__btn",
            settings: this.appSettings
        }
    },
    methods:{
        clickProjects(){
            this.projects = "pages__nav__btn pages__nav__btn__active";
            this.nieuws = "pages__nav__btn";
            this.vacatures = "pages__nav__btn";
            this.openingsuren = "pages__nav__btn";
            this.media = "pages__nav__btn";
            sessionStorage.DevPage = "projects"
            this.$emit('click_nav', 'projects');
        },
        clickNieuws(){
            this.projects = "pages__nav__btn";
            this.nieuws = "pages__nav__btn pages__nav__btn__active";
            this.vacatures = "pages__nav__btn";
            this.openingsuren = "pages__nav__btn";
            this.media = "pages__nav__btn";
            sessionStorage.DevPage = "nieuws"
            this.$emit('click_nav', 'nieuws');
        },
        clickVacatures(){
            this.projects = "pages__nav__btn";
            this.nieuws = "pages__nav__btn";
            this.vacatures = "pages__nav__btn pages__nav__btn__active";
            this.openingsuren = "pages__nav__btn";
            this.media = "pages__nav__btn";
            sessionStorage.DevPage = "vacature"
            this.$emit('click_nav', 'vacature');
        },
        clickOpeningsuren(){
            this.projects = "pages__nav__btn";
            this.nieuws = "pages__nav__btn";
            this.vacatures = "pages__nav__btn";
            this.openingsuren = "pages__nav__btn pages__nav__btn__active";
            this.media = "pages__nav__btn";
            sessionStorage.DevPage = "openingsuren"
            this.$emit('click_nav', 'openingsuren');
        },
        clickMedia(){
            this.projects = "pages__nav__btn";
            this.nieuws = "pages__nav__btn";
            this.vacatures = "pages__nav__btn";
            this.openingsuren = "pages__nav__btn";
            this.media = "pages__nav__btn pages__nav__btn__active";
            sessionStorage.DevPage = "media";
            this.$emit('click_nav', 'media');
        },
    },
    created(){
        if(sessionStorage.DevPage !== undefined){
            if(sessionStorage.DevPage === 'projects'){
                this.clickProjects();
            } else if(sessionStorage.DevPage === 'nieuws'){
                this.clickNieuws();
            } else if(sessionStorage.DevPage === 'vacature'){
                this.clickVacatures();
            } else if(sessionStorage.DevPage === 'openingsuren'){
                this.clickOpeningsuren();
            } else if(sessionStorage.DevPage === 'media'){
                this.clickMedia();
            }
        } else{
            if(this.status.pagesPage === 'projects'){
                this.projects = "pages__nav__btn pages__nav__btn__active";
                this.nieuws = "pages__nav__btn";
                this.vacatures = "pages__nav__btn";
                this.openingsuren = "pages__nav__btn";
                this.media = "pages__nav__btn";
            } else if(this.status.pagesPage === 'nieuws' || sessionStorage.DevPage === 'nieuws'){
                this.projects = "pages__nav__btn";
                this.nieuws = "pages__nav__btn pages__nav__btn__active";
                this.vacatures = "pages__nav__btn";
                this.openingsuren = "pages__nav__btn";
                this.media = "pages__nav__btn";
            } else if(this.status.pagesPage === 'vacature' || sessionStorage.DevPage === 'vacature'){
                this.projects = "pages__nav__btn";
                this.nieuws = "pages__nav__btn";
                this.vacatures = "pages__nav__btn pages__nav__btn__active";
                this.openingsuren = "pages__nav__btn";
                this.media = "pages__nav__btn";
            } else if(this.status.pagesPage === 'openingsuren' || sessionStorage.DevPage === 'openingsuren'){
                this.projects = "pages__nav__btn";
                this.nieuws = "pages__nav__btn";
                this.vacatures = "pages__nav__btn";
                this.openingsuren = "pages__nav__btn pages__nav__btn__active";
                this.media = "pages__nav__btn";
            } else if(this.status.pagesPage === 'media' || sessionStorage.DevPage === 'media'){
                this.projects = "pages__nav__btn";
                this.nieuws = "pages__nav__btn";
                this.vacatures = "pages__nav__btn";
                this.openingsuren = "pages__nav__btn";
                this.media = "pages__nav__btn pages__nav__btn__active";
            }
        }
    },
}
</script>